import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { SeoManager } from './seo/SeoManager'


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <SeoManager />
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App